import { io } from 'socket.io-client';
import { notificationsApi } from './notificationsApi';
// 避免循环依赖，延迟导入store
let storeInstance = null;
export function setStoreInstance(store) {
    storeInstance = store;
}
class WebSocketService {
    constructor() {
        Object.defineProperty(this, "socket", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "reconnectAttempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "maxReconnectAttempts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 5
        });
        Object.defineProperty(this, "reconnectDelay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1000
        });
    }
    connect(token) {
        if (this.socket?.connected) {
            return;
        }
        const wsUrl = process.env.WS_URL || 'ws://localhost:3000';
        this.socket = io(wsUrl, {
            auth: {
                token,
            },
            transports: ['websocket'],
            reconnection: true,
            reconnectionDelay: this.reconnectDelay,
            reconnectionAttempts: this.maxReconnectAttempts,
        });
        this.setupEventListeners();
    }
    setupEventListeners() {
        if (!this.socket)
            return;
        this.socket.on('connect', () => {
            console.log('WebSocket connected');
            this.reconnectAttempts = 0;
        });
        this.socket.on('disconnect', (reason) => {
            console.log('WebSocket disconnected:', reason);
        });
        this.socket.on('connect_error', (error) => {
            console.error('WebSocket connection error:', error);
            this.reconnectAttempts++;
            if (this.reconnectAttempts >= this.maxReconnectAttempts) {
                console.error('Max reconnection attempts reached');
                this.disconnect();
            }
        });
        // 监听新通知
        this.socket.on('notification', (notification) => {
            console.log('New notification received:', notification);
            // 使通知列表缓存失效，触发重新获取
            if (storeInstance) {
                storeInstance.dispatch(notificationsApi.util.invalidateTags(['Notification']));
            }
            // 可选：显示浏览器通知
            if ('Notification' in window && Notification.permission === 'granted') {
                new Notification(notification.title, {
                    body: notification.content,
                    icon: '/logo.png',
                });
            }
        });
        // 监听通知已读状态更新
        this.socket.on('notification:read', (data) => {
            console.log('Notification marked as read:', data);
            if (storeInstance) {
                storeInstance.dispatch(notificationsApi.util.invalidateTags(['Notification']));
            }
        });
        // 监听通知删除
        this.socket.on('notification:deleted', (data) => {
            console.log('Notification deleted:', data);
            if (storeInstance) {
                storeInstance.dispatch(notificationsApi.util.invalidateTags(['Notification']));
            }
        });
    }
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.reconnectAttempts = 0;
        }
    }
    // 发送消息到服务器
    emit(event, data) {
        if (this.socket?.connected) {
            this.socket.emit(event, data);
        }
        else {
            console.warn('WebSocket not connected, cannot emit event:', event);
        }
    }
    // 请求浏览器通知权限
    async requestNotificationPermission() {
        if ('Notification' in window && Notification.permission === 'default') {
            const permission = await Notification.requestPermission();
            return permission === 'granted';
        }
        return Notification.permission === 'granted';
    }
    isConnected() {
        return this.socket?.connected || false;
    }
}
export const websocketService = new WebSocketService();
